module.exports = __webpack_public_path__ + "images/5cdf277c2c2efc47ef5acdfaea887c9e.png";